module.exports = __webpack_public_path__ + "static/media/interaction.a670bc5b.svg";